import Close from "public/assets/close-x.svg"

export default function Modal({ children, isOpen, closeModal, focusRef }) {
  return isOpen ? (
    <>
      <div
        onClick={() => closeModal()}
        className="overlay fixed bottom-0 left-0 right-0 top-0 z-[99998] h-full w-full bg-white bg-opacity-95"
      />

      <div className="fixed right-0 top-0 z-[100000] h-16 w-full">
        <button
          onClick={() => closeModal()}
          aria-label="Close Modal"
          title="Close Modal"
          className="close-modal-btn absolute right-1 top-1 p-3"
        >
          <Close className="duration-300 hover:rotate-90" />
        </button>
      </div>
      <div
        tabIndex={0}
        ref={focusRef}
        className="modal absolute top-0 z-[99999] max-h-[100dvh] w-full max-w-screen-lg overflow-y-auto md:left-1/2 md:top-1/2 md:-translate-x-1/2 md:-translate-y-1/2 md:transform md:overflow-y-visible"
      >
        {children}
      </div>
    </>
  ) : null
}
